import { Col, Row } from "antd";
import React from "react";
import MenuItemLayout from "./MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import story from "../../../assets/images/story.png";
const OurStory = () => {
  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="من نحن"
      subTitle="عن تكافل"
      urlImage={banner}
      className="takaful--our-story"
    >
      <Row dir="rtl" gutter={16} justify={"space-between"}>
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
        <Col
          xxl={10}
          xl={10}
          lg={10}
          md={24}
          sm={24}
          xs={24}
          className="takaful--story-text-content"
        >
          <p className="takaful--story-text">
            عن تكافل : جمعية أهلية في منطقة المدينة المنورة تأسست في عام 1433هـ،
            مسجلة في المركز الوطني لتنمية القطاع غير الربحي برقم (590)، تهدف إلى
            بناء أنموذج مؤسسي ريادي في رعاية وتنمية اليتيم بالشراكة الفاعلة مع
            الداعمين وباحترافية عالية من العاملين في الجمعية .
          </p>
          {/* <p className="takaful--story-text">
            بعيون حائرة يقلبها هنا وهناك يلتمس دفئا كان قد افتقده، وظلا يتفيأ
            ظلاله من لهيب الحياة ومشاقها، ويد حانية تقيل عثرته وتمسح عنه غبار
            العوز، حتى كان هنا.
          </p>
          <p className="takaful--story-text">
            هنا نحن ومن على ثرى طيبة الطيبة التي سار عليها أعظم يتيم صلى الله
            عليه وسلم، وهو من أوصى واستوصى باليتيم خيراً، انطلقت تكافل لتقدم
            لليتيم الرعاية الشاملة معيشياً وتعليمياً وصحياً وتربوياً تمكيناً له
            في شتى مناحي الحياة، مدعومة بكوادر متخصصة، ورعاية من مؤسسات حكومية
            وأهلية.
          </p>*/}
        </Col>
        <Col
          xxl={11}
          xl={11}
          lg={11}
          md={24}
          sm={24}
          xs={24}
          style={{ padding: "1vh" }}
        >
          <img className="takaful--our-story-img" src={story} alt="" />
        </Col>
        <Col xxl={1} xl={1} lg={1} md={1} sm={0} xs={0}></Col>
      </Row>
    </MenuItemLayout>
  );
};

export default OurStory;
